import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import get from "lodash/get";
import ContextComponentWrapper from '../../components/contextComponent/ContextComponentWrapper';
import { generateComponentKey } from '../utils';
export function render(node, path) {
    if (!node.Content)
        return null;
    var _a = node.Content, type = _a.type, props = _a.props, format = _a.format, overrideConfig = _a.overrideConfig;
    var componentKey = get(node, 'Content.props.componentKey', get(node, 'Content.componentKey', generateComponentKey(path, type !== null && type !== void 0 ? type : format)));
    return (_jsx(ContextComponentWrapper, { contextId: type, contextProps: props, overrideConfig: overrideConfig, format: format, componentKey: componentKey }));
}
